import config from 'constants/config'

export const OIDC_PROVIDERS = ['password', 'google', 'sso'] as const

export type OidcProvider = typeof OIDC_PROVIDERS[number]

const CLIENT_ID_CONFIG_KEY: Record<OidcProvider, keyof App.Features> = {
  password: 'OIDC_CLIENT_ID_PASSWORD',
  google: 'OIDC_CLIENT_ID_GOOGLE',
  sso: 'OIDC_CLIENT_ID_SSO',
}

export function isOidcProvider(value: unknown): value is OidcProvider {
  return typeof value === 'string' && (OIDC_PROVIDERS as ReadonlyArray<string>).includes(value)
}

export function getOidcClientId(provider: OidcProvider): string {
  return (config[CLIENT_ID_CONFIG_KEY[provider]] as string | undefined) ?? ''
}

// An unregistered provider must not render a button: an authorize redirect with
// an empty client_id fails at svc-auth.
export function isOidcProviderConfigured(provider: OidcProvider): boolean {
  return !!config.OIDC_AUTHORITY && !!getOidcClientId(provider)
}
